export default __webpack_public_path__ + "static/media/BatchPrint2.f31c9e9d.svg";